import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const stats = [
  { label: 'Usuarios únicos', value: '---' },
  { label: 'Visitas totales', value: '---' },
  { label: 'Páginas vistas', value: '---' },
  { label: 'Clicks en WhatsApp', value: '---' },
  { label: 'Clicks en SIEVAS', value: '---' },
  { label: 'Clicks en traducción', value: '---' },
];

const Stats = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="max-w-3xl mx-auto py-16 px-4">
        <h1 className="text-4xl font-bold text-gray-800 mb-8 text-center">Estadísticas del Sitio</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {stats.map((stat, idx) => (
            <div key={idx} className="bg-white rounded-lg shadow p-6 flex flex-col items-center justify-center border-l-4 border-orange-400">
              <span className="text-lg font-semibold text-gray-700 mb-2">{stat.label}</span>
              <span className="text-3xl font-bold text-orange-600">{stat.value}</span>
            </div>
          ))}
        </div>
        <p className="mt-12 text-gray-500 text-center text-sm">* Los datos se pueden conectar a Google Analytics, Posthog u otro sistema de métricas.</p>
      </main>
      <Footer />
    </div>
  );
};

export default Stats;

